/**
 * Dependencies.
 */
import applicationConstant from '@/modules/main/constants/application.constant';
import { BaseService } from '@/modules/main/services/base.service';

import { ServicePointDeliverAlertModel } from './deliver-alert.model';

/**
 * Service.
 */
class ServicePointDeliverAlertService extends BaseService<
ServicePointDeliverAlertModel
> {
  /**
   * Constructor.
   */
  constructor() {
    super(
      ServicePointDeliverAlertModel,
      ServicePointDeliverAlertModel.name,
      applicationConstant.apiServicePointPrivateUrl
    );
  }
}

/**
 * Export `servicePointDeliverAlertService`.
 */
export const servicePointDeliverAlertService = new ServicePointDeliverAlertService();
